import { produce } from 'immer';

import { ChangeMobileCampaignServiceEditor } from '../../actions/campaignServiceEditor/changeMobileCampaignServiceEditor';
import { CampaignServiceEditorState } from '../../typings/campaignServiceEditor';

export function changeMobileCampaignServiceEditor(
    state: CampaignServiceEditorState,
    action: ChangeMobileCampaignServiceEditor
): CampaignServiceEditorState {
    return produce(state, draft => {
        const { editorId, isMobile } = action;

        draft[editorId].isMobile = isMobile;
    });
}
